export default __webpack_public_path__ + "static/media/iconReset.4b6152f7.svg";